import { render, staticRenderFns } from "./bbfx.vue?vue&type=template&id=6e37cca0&scoped=true"
import script from "./bbfx.vue?vue&type=script&lang=js"
export * from "./bbfx.vue?vue&type=script&lang=js"
import style0 from "./bbfx.vue?vue&type=style&index=0&id=6e37cca0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e37cca0",
  null
  
)

export default component.exports